module.exports = __webpack_public_path__ + "static/media/icon_add_avatar.60a48309.png";